module.exports = __webpack_public_path__ + "img/line-chart.fa3b8538.svg";